<script setup lang="ts">
import { Primitive, type PrimitiveProps } from "radix-vue";
import { twMerge } from "tailwind-merge";
import { type HTMLAttributes, normalizeClass } from "vue";

import { type ButtonVariants, buttonVariants } from "./index.ts";

interface Props extends PrimitiveProps {
	variant?: ButtonVariants["variant"];
	size?: ButtonVariants["size"];
	as?: string;
	class?: HTMLAttributes["class"];
}

const props = withDefaults(defineProps<Props>(), {
	as: "button",
});
</script>

<template>
	<Primitive
		:as="as"
		:as-child="asChild"
		:class="twMerge(buttonVariants({ variant, size }), normalizeClass(props.class))"
	>
		<slot />
	</Primitive>
</template>
